import { VerticalRepository } from "../../../repositories/repositories";
import { IErrorRedirectService } from "../../../core/services/errorRedirectService/errorRedirect.service";
import { ErrorInformation } from "../../../core/services/errorRedirectService/errorInformation.model";
import { IVertical, Constants } from "../../../models/models";

export class VerticalGateway {
    public static $inject = ['verticalRepository', 'errorRedirectService'];

    public constructor(private verticalRepository: VerticalRepository, private errorRedirectService: IErrorRedirectService) { }

    public loadVerticals(): ng.IPromise<any> {
        return this.verticalRepository.getVerticals()
            .then((result: IVertical[]) => {
                return result;
            })
            .catch((reason: string) => {
                const error = new ErrorInformation();
                error.errorMessage = reason;
                error.errorDetails = reason;
                this.errorRedirectService.redirectToErrorState(error);
                return error;
            });
    }

    public loadVerticalByAlias(alias: string): ng.IPromise<any> {
        return this.verticalRepository.getVerticals()
            .then((result: IVertical[]) => {
                const restaurantVerticals = result.filter((verticalResource) => verticalResource.alias === Constants.Verticals.Restaurant);
                const restaurantVertical = restaurantVerticals[0];
                return restaurantVertical;
            })
            .catch((reason: string) => {
                const error = new ErrorInformation();
                error.errorMessage = reason;
                error.errorDetails = reason;
                this.errorRedirectService.redirectToErrorState(error);
                return error;
            });
    }
}